import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"

type PublicInfoPageProps = {
  eyebrow: string
  title: string
  children: ReactNode
}

export function PublicInfoPage({ eyebrow, title, children }: PublicInfoPageProps) {
  return (
    <main className="min-h-screen bg-[#09091f] px-6 py-10 text-[#f8f7ff] sm:px-8">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_16%_14%,rgba(192,224,64,0.18),transparent_28%),radial-gradient(circle_at_86%_12%,rgba(56,189,248,0.14),transparent_30%),radial-gradient(circle_at_74%_86%,rgba(238,63,143,0.12),transparent_24%)]"
      />
      <div className="relative mx-auto flex min-h-[calc(100vh-5rem)] w-full max-w-3xl flex-col">
        <header className="flex items-center justify-between gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-3 rounded-full text-sm font-extrabold text-white transition hover:text-[#c8e840]"
          >
            <img
              src="/wild-guess-logo-transparent.png"
              alt="Wild Guess"
              className="h-10 w-auto"
            />
          </Link>
          <a
            href="mailto:henry@clubwestcreative.com"
            className="rounded-full border border-white/16 px-4 py-2 text-sm font-bold text-white/78 transition hover:border-[#c8e840]/70 hover:text-[#c8e840]"
          >
            Contact
          </a>
        </header>

        <section className="mt-14 rounded-[28px] border border-white/12 bg-white/[0.06] p-6 shadow-[0_34px_110px_-72px_rgba(0,0,0,0.9)] backdrop-blur-md sm:p-10">
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#c8e840]">
            {eyebrow}
          </p>
          <h1 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-[0.95] text-white sm:text-6xl">
            {title}
          </h1>
          <div className="prose prose-invert mt-8 max-w-none prose-headings:font-display prose-headings:text-white prose-p:text-white/72 prose-a:text-[#c8e840] prose-strong:text-white prose-li:text-white/72">
            {children}
          </div>
        </section>
      </div>
    </main>
  )
}
